import {createStore, applyMiddleware, compose} from 'redux';
import thunk from 'redux-thunk';

const actionToReducer = {};

export function reducer(state, action) {
    if (!actionToReducer.hasOwnProperty(action.type)) {
        if (action.type.indexOf('@@') === 0) {
            return state;
        }

        throw new Error(`Reducer for action ${action.type} is not registered.`);
    }

    return actionToReducer[action.type](state, action);
}

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
export const store = createStore(
    reducer,
    {},
    composeEnhancers(applyMiddleware(thunk))
);

export const dispatch = store.dispatch;

export function regReducer(actionId, reducer) {
    if (actionToReducer.hasOwnProperty(actionId)) {
        throw new Error(
            `Reducer for action ${actionId} is already registered.`
        );
    }

    actionToReducer[actionId] = reducer;
}
